export const locale = {
  lang: 'es',
  data: {
    'NAV': {
      'APPLICATIONS': 'Aplicaciones',
      'CONFIG': 'Configuración',
      'TOOLS': {
        'TITULO': 'Herramientas',
        'CHAT': 'Chat',
        'TODO': 'Lista de tareas',
        'BROKER': 'Configuración por broker',
        'CHANGELOG': 'Registro de cambios',
        'KNOWLEDGE': 'Base de conocimiento',
        'WEB_COM_PROF':'Perfil de la empresa web',
      },
      'RESULTS': {
        'TITULO': 'Resultados',
        'ENLACES': {
          'TI': 'Reporteador',
          'TI_ESPANA': 'Reportes en línea',
          'COVID': 'Resultados de la encuesta COVID'
        },
        'ENLACES5': {
          'TI': 'Reultados 5.0',
          'COVID': 'Resultados de la encuesta COVID'
        },
        'ENLACES_ACTION_GO':{
          'TITULO':'Plan de Acción - Líderes',
        },
        'ENLACES_GO_FLOW':{
          'TITULO':'Resultados Go Flow',
        }
      },
      'ACADEMY'        : {
        'TITULO': 'Prueba de Academy',
        'BADGE': '69'
      },
      'CERTIFICAR'        : {
        'TITULO': 'Certificar',
        'TITULOIZZI': 'Izzi',
        'TITULO_ESPAIN': 'Diagnosticar',
        'BADGE': '69',
        'SUBPRODUCTOS': {
          '0': 'Certificar',
          '1': 'Certificar 2.0',
          '2': 'Izzi',
          '3': 'Certificar 3.0',
          '4': 'Certificar plata',
          'SPA': 'Configurar encuesta',
        }
      },
      'CERTIFICARN35'        : {
        'TITULO': 'Certificar NOM 035',
        'BADGE': '69'
      },
      'MEDIR'        : {
        'TITULO': 'Medir',
        'BADGE': '69',
        'SUBPRODUCTOS': {
          '0': 'Medir',
          '1': 'Medir mejorado',
          '2': 'Medir + MST',
          '3': 'Medir por áreas',
          '4': 'Medir por líderes',
          '5': 'Medir por dimensiones',
          '6': 'Medir para certificar',
          '7': 'Medir 3.0',
        }
      },
      'PULSE'        : {
        'TITULO': 'Pulse Check',
        'BADGE': '69',
        'SUBPRODUCTOS': {
          '0': 'Pulse Check',
          '1': 'Pulse Check 3.0',
        }
      },
      'FOCUS'        : {
        'TITULO': 'Focus area',
        'BADGE': '69'
      },
      'ENCUESTAS'        : {
        'TITULO': 'Certificaciones adicionales',
        'BADGE': '69',
        'SUBPRODUCTOS': {
          '0': 'AMCO',
          '1': 'Trabajo digno',
          '2': 'Primer empleo',
        }
      },
      'NORMA35': {
        'TITULO': 'Norma 035'
      },
      'NOM35BETHE': {
        'TITULO': 'Norma 035 better'
      },
      'NOM35PLA': {
        'TITULO': 'Norma 035 plata'
      },
      'NOM35V3': {
        'TITULO': 'Norma 035 3.0'
      },
      'LANGUAJE'        : {
        'TITULO': 'Prueba idioma',
        'BADGE': '69'
      },
      'LOGIN'        : {
        'TITULO': 'Prueba login',
        'BADGE': '69'
      },
      'PROFILECREATOR'        : {
        'TITULO': 'Creador de perfiles',
        'BADGE': '69'
      },
      'PROFILELIST'        : {
        'TITULO': 'Información de empresas',
        'BADGE': '69'
      },
      'NOPRODUCTOS'        : {
        'TITULO': 'No cuenta con productos',
        'BADGE': '69'
      },
      'RESPTI': {
        'TITULO': 'Responsable TI'
      },
      'REQTEC': {
        'TITULO': 'Requerimientos técnicos'
      },
      'CLOUD': {
        'TITULO': 'Gestor de archivos',
        'TITULO_ESPANA': 'Reporte de descargas',
      },
      //Culture Audit
      'CULTURE': {
        'TITULO': 'Culture audit'
      },
      //Culture Audit2
      'CULTURE2': {
        'TITULO': 'Culture Audit 5.0 '
      },
      //Culture Audit training
      'CATR': {
        'TITULO': 'Culture Audit Training'
      },
      //Feedback
      'FEEDBACK': {
        'TITULO': 'Feedback'
      },
      //Acercade
      'ABOUT': {
        'TITULO':'Actualizaciones'
      },
      'QUESTIONS': {
        'TITULO':'Preguntas frecuentes'
      },
      'VIDEOS': {
        'TITULO':'Videos instruccionales'
      },
      'CONSULTAR_E': {
        'TITULO':'Consultar encuestas'
      },
      'CALEND_SUR': {
        'TITULO':'Calendario de encuestas'
      },'VIDEOSADMIN': {
        'TITULO':'Videos administrador'
      },'AUDITORIA-AUTO': {
        'TITULO':'Auditoría automatizada'
      },'LOG_SISTEMA': {
        'TITULO':'Log del sistema'
      },'TIPS': {
        'TITULO':'Norma tips'
      },'ENCUESTA': {
        'TITULO':'Colaboradores nuevos'
      },'CULTURETURQUIA1': {
        'TITULO': 'Culture Brief ve Culture Audit 5.0'
      },'CULTURETURQUIA2': {
        'TITULO': 'Culture Brief 5.0'
      },'CULTURETURQUIA3': {
        'TITULO': 'Culture Audit 5.0'
      },
      'CULTUREMX1': {
        'TITULO': 'Culture Audit 5.0'
      },'CULTUREMX2': {
        'TITULO': 'Culture Audit Costa Rica'
      },'CULTUREMX3': {
        'TITULO': 'Culture Audit GoFlow'
      },'CULTUREMX4': {
        'TITULO': 'Culture Audit 5.0 Panamá'
      },'CULTUREMX5': {
        'TITULO': 'Culture Audit 5.0 Strategic Partners'
      },'CULTUREMX6': {
        'TITULO': 'Culture Audit 2021 México'
      },'CULTUREMX7': {
        'TITULO': 'Culture Audit 2021 Costa Rica'
      },'CULTUREMX8': {
        'TITULO': 'Culture Audit 2021 Panamá'
      },
      'CULTUREMX9': {
        'TITULO': 'SP 2021'
      },
      'CULTUREMX10': {
        'TITULO': 'Culture Audit GoFlow 2 2021'
      },
      'CULTUREMX11': {
        'TITULO': 'SP 2022'
      },
      'CULTUREMX12': {
        'TITULO': 'Culture Audit GoFlow 2-2022'
      },
      'CULTUREMX13': {
        'TITULO': 'Culture Audit Estandar 1'
      },
      'CULTUREMX14': {
        'TITULO': 'Culture Audit® CA&C'
      },
      'CULTUREMX15': {
        'TITULO': 'Culture Brief (certificar) 2022'
      },
      'CULTUREMX16': {
        'TITULO': 'Culture Audit (certificar, rkg.) 2022'
      },
      'CULTUREMX17': {
        'TITULO': 'Culture Audit (certificar, rkg. y adic.) 2022'
      },
      'CULTUREMX18': {
        'TITULO': 'Culture Audit (certificar, rkg. y adic.) 2024'
      },
      'CULTUREMX19': {
        'TITULO': 'Culture Brief (certificar) 2024'
      },
      'CULTUREMX20': {
        'TITULO': 'Culture Audit (certificar y ranking) 2024'
      },
      'CULTURECH1': {
        'TITULO': 'Culture Audit'
      },'CULTURECH2': {
        'TITULO': 'Culture Audit 5.0'
      },'CULTURECH3': {
        'TITULO': 'Culture Audit SP'
      },'CULTURECH4': {
        'TITULO': 'Culture Audit 5.0'
      },'CULTURECH5': {
        'TITULO': 'Culture Audit 4All'
      },
      'CULTUREESP1':{
        'TITULO': 'Culture Audit'
      },
      'CULTUREESP2':{
        'TITULO': 'Culture Audit 5.0'
      },
      'CULTUREESP3':{
        'TITULO': 'Action Plan'
      },
      'CULTUREBRI':{
        'TITULO': 'Culture Brief',
        'Culture Brief': 'Culture Brief',
      },
      'CULTUREAUDI':{
        'TITULO': 'Culture Audit',
        'Culture Audit': 'Culture Audit',
      },
      'CONTACTO':{
        'TITULO': 'Contacto'
      },
      'ACTIONGOADMIN':{
        'TITULO': 'Action GO® administrador'
      },
      'ACTIONGO':{
        'TITULO': 'Action GO®'
      },
      'LEADERGOADMIN':{
        'TITULO': 'Leader GO® administrador',
      },
      'LEADERGOUSER':{
        'TITULO': 'Leader GO®',
      },
      'medir_INNO':{
        'TITULO': 'Innmotion survey',
      },
      'CULTURE_OZEL':{
        'TITULO': 'Lista Especial',
      },
      'Culture_Ozel_TR1':{
        'TITULO': 'Responsabilidad Social y Voluntariado',
      },
      'CONTROL_SURVE':{
        'TITULO': 'Control de encuestas',
      },
      'CONSUL_REQUE':{
        'TITULO': 'Consultar requirimientos',
      },
      'SURVEY_GENERIC':{
        'TITULO': 'Reporte encuesta generica',
      },
      'RAWDATA_FINDER':{
        'TITULO': 'Consultar Raw Data',
      },




    }
  }
};
